import { CloverIcon } from "@phosphor-icons/react";
import type { ReactNode } from "react";

/**
 * Sign-in sits on the same near-black ground as the site, lit by a single clover-green glow.
 * Nothing here competes with the form.
 */
export function AuthLayout({
  title,
  description,
  children,
  footer,
}: {
  title: string;
  description?: string;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <div className="relative grid min-h-full place-items-center overflow-hidden px-4 py-12">
      <div
        aria-hidden
        className="bg-accent/8 pointer-events-none absolute -top-40 left-1/2 size-[640px] -translate-x-1/2 rounded-full blur-[120px]"
      />

      <div className="relative w-full max-w-[380px]">
        <div className="mb-7 flex flex-col items-center gap-3">
          <span className="bg-accent text-accent-ink clover-sprout grid size-11 place-items-center rounded-full">
            <CloverIcon weight="bold" className="size-6" />
          </span>
          <span className="display text-ink text-[22px] leading-none font-bold tracking-tight">
            LUCKY&nbsp;TRY
          </span>
          <span className="text-micro text-faint font-semibold uppercase">Staff console</span>
        </div>

        <div className="rounded-card border-line bg-surface border p-6">
          <h1 className="display text-heading text-ink">{title}</h1>
          {description && <p className="text-caption text-muted mt-1.5">{description}</p>}
          <div className="mt-5">{children}</div>
        </div>

        {footer && <div className="text-caption text-muted mt-4 text-center">{footer}</div>}
      </div>
    </div>
  );
}
